import type { Media } from '../../types/props.js'
import { Dialog, DialogContent } from '../../components/dialog.js'
import { Picture, Text } from '../../components/index.js'
import { cn } from '../../helpers/index.js'
import type { Img } from '../../types/props.js'

export type TextModalType = {
  textVisible: boolean
  extension?: {
    textPcImg: Img
    textMobileImg: Img
    textTitle: string
    text: string
    textDesc: string
  }
  onCloseModal: () => void
}

const TextModal = (props: TextModalType) => {
  const { textVisible, extension, onCloseModal } = props

  return (
    <Dialog open={textVisible} onOpenChange={() => onCloseModal()}>
      <DialogContent className="tablet:max-w-[896px] md-tablet:h-[490px] md-tablet:w-[358px] tablet:rounded-2xl z-[9999] mx-auto rounded-lg border-none bg-white p-0 [&_button]:hidden">
        <div className="tablet:rounded-2xl md-tablet:flex md-tablet:flex-col overflow-hidden rounded-lg">
          <div className="md-tablet:flex-1 min-h-[260px] w-full">
            <Picture
              source={`${extension?.textPcImg?.url || ''} , ${extension?.textMobileImg?.url || ''} 767`}
              className="size-full"
              imgClassName="w-full h-full object-cover"
            />
          </div>
          <div className="tablet:inset-x-8 tablet:top-8 absolute inset-x-4 top-4">
            <Text html={extension?.textTitle} className="tablet:text-[24px] text-[20px] font-bold leading-[1.2]" />
          </div>
          <div onClick={() => onCloseModal()} className="absolute right-4 top-4 cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <g clipPath="url(#clip0_2548_10038)">
                <path
                  d="M5.63545 6.13604C6.02592 5.74546 6.65913 5.74551 7.04966 6.13604L11.9994 11.0858L16.9492 6.13604C17.3397 5.74552 17.9729 5.74546 18.3634 6.13604C18.7538 6.52659 18.7538 7.15972 18.3634 7.55025L13.4136 12.5L18.3634 17.4497C18.7538 17.8403 18.7538 18.4734 18.3634 18.864C17.9729 19.2545 17.3397 19.2545 16.9492 18.864L11.9994 13.9142L7.04966 18.864C6.65913 19.2545 6.02592 19.2545 5.63545 18.864C5.24501 18.4734 5.24502 17.8403 5.63545 17.4497L10.5852 12.5L5.63545 7.55025C5.24502 7.15972 5.24501 6.52658 5.63545 6.13604Z"
                  fill="white"
                />
              </g>
            </svg>
          </div>
          <div className="tablet:p-8 tablet:max-h-60 md-tablet:flex-1 overflow-y-auto p-4 text-[#080A0F]">
            <Text html={extension?.text} className=" tablet:text-2xl text-xl font-bold leading-[1.2]" />
            <br />
            <Text html={extension?.textDesc} className="tablet:leading-[1.2] pt-1 text-base font-bold leading-[1.4]" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export { TextModal }
